import { render, staticRenderFns } from "./PointsStructure.vue?vue&type=template&id=3edb315f&scoped=true"
import script from "./PointsStructure.vue?vue&type=script&lang=ts"
export * from "./PointsStructure.vue?vue&type=script&lang=ts"
import style0 from "./PointsStructure.vue?vue&type=style&index=0&id=3edb315f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb315f",
  null
  
)

export default component.exports